export default [
  { value: 'page', label: 'Seiten' },
  { value: 'attachment', label: 'Dokumente' },
  { value: 'product', label: 'Produkte' },
]
